// extracted by mini-css-extract-plugin
export default {"loadingContainer":"LoadingFeedback_loadingContainer__JTyfr","loadingTitle":"LoadingFeedback_loadingTitle__Zf5wK","loadingMessage":"LoadingFeedback_loadingMessage__jDxss"};